import { OmniaObjectType } from "../generated/enums"
import { ClientState } from "../shell"
import { setDates, toDate } from "../utils/date"
import { HoldingEvent, HoldingEventUser, HoldingSession, HoldingSessions, SessionType } from "./types"

/** @internal */
export function setupHoldingSessions(sessions: HoldingSession[], currentSessionId: string): HoldingSessions {

    sessions = setDates(sessions || [], ["StartDate", "InactiveSince"], false)

    sessions = sessions.map(s => ({
        ...s,
        CurrentSession: s.SessionId == currentSessionId,
        ConflictId: getConflictId(s.ClientState)
    }))

    sessions = sessions.filter(s => shouldIncludeSessionType(s.SessionType))

    const active = sessions.filter(s => !s.InactiveSince)

    return {
        active,
        sessions
    }
}

/** @internal */
export function setupInitialHoldingEvents(events: HoldingEvent[], users: HoldingEventUser[]): HoldingEvent[] {

    function getUserName(u: HoldingEventUser) {
        return [u.FirstName, u.LastName].join(" ").trim() || u.Email
    }

    const index = new Map((users || []).map(s => [s.Id, { name: getUserName(s), email: s.Email }]))

    events = events.map(e => {

        const user = index.get(e.UserId)

        return {
            ...e,
            Date: getEventDate(<any>e.Date),
            Unread: false,
            UserName: user?.name,
            UserEmail: user?.email
        }

    })

    return events


}

/** @internal */
export function setupHoldingEvents(events: HoldingEvent[], sessions: HoldingSessions): HoldingEvent[] {

    const index = new Map(sessions.sessions.map(s => [s.SessionId, s]))

    events = events.map(e => {

        const s = index.get(e.SessionId)

        return {
            ...e,
            Date: getEventDate(<any>e.Date),
            UserName: s?.UserName,
            CurrentSession: s?.CurrentSession
        }

    })

    return events

}

/** @internal */
export function getConflictId(state: ClientState) {

    const a = state?.activity

    if (a) {

        /**
         * The id is either provided directly as part of the client state's activity,
         * or a default id can be derived in case of updates (action == "u") or deletions (action == "d"),
         * if both a resource type and id have been provided
        */

        if (a.conflictId) return a.conflictId

        if (a.resourceType && a.resourceId && (/^[ud]$/.test(a.action))) {
            const type = OmniaObjectType[a.resourceType].toLowerCase()
            return `edit/${type}/${a.resourceId}`
        }

    }
}

function getEventDate(date: string): Date {
    return date
        ? toDate(date, false)
        : undefined
}

function shouldIncludeSessionType(type?: SessionType) {

    switch (type || 0) {

        case SessionType.FieldScoutSync:
        case SessionType.Connect:
            return false

        default:
            return true

    }
}
